const initialState = {
  status: "idle",
  sessionId: null,
  hostPeerId: null,
  controllerPeerId: null,
  screenProducerId: null,
  bounds: null,
  requestedAt: null,
  acceptedAt: null,
  expiresAt: null,
  reason: null,
};

const fromSession = (session, reason = null) => {
  if (!session) {
    return { ...initialState, reason };
  }

  return {
    status: session.status || "idle",
    sessionId: session.sessionId || null,
    hostPeerId: session.hostPeerId || null,
    controllerPeerId: session.controllerPeerId || null,
    screenProducerId: session.screenProducerId || null,
    bounds: session.bounds || null,
    requestedAt: session.requestedAt || null,
    acceptedAt: session.acceptedAt || null,
    expiresAt: session.expiresAt || null,
    reason: reason || null,
  };
};

const remoteControl = (state = initialState, action) => {
  switch (action.type) {
    case "SET_REMOTE_CONTROL_SESSION": {
      const { session, reason } = action.payload;

      return fromSession(session, reason);
    }
    case "CLEAR_REMOTE_CONTROL":
    case "CLEAR_STATE":
      return initialState;
    default:
      return state;
  }
};

export default remoteControl;
